@if (product$ | async; as product) {
  <div class="tabs-container">
    @for (component of components$ | async; track component; let i = $index) {
      @if (showTab(component)) {
        <a (click)="select(i); clickOnTab(i)" [class.active]="i === activeTabNum" class="tab-header">
          <span [id]="generateTabHeaderId(i)">
            {{ component.title | cxTranslate: { param: tabTitleParams[i] | async } }}
          </span>
          @if (isMobileView) {
            <span [class.active]="i === activeTabNum" class="chevron-image"></span>
          }
        </a>
        <div [class.active]="i === activeTabNum" class="tab-content">
          <ng-template [cxOutlet]="component.flexType" [cxOutletContext]="{}">
            <div class="container">
              <ng-container [cxComponentWrapper]="component"></ng-container>
              @if (component?.uid === 'ProductDocumentsTabComponent' && userPermissionService.downloadProductInfo) {
                <div>
                  <p class="download-new-line-form" (click)="downloadNewLineForm(product)">
                    <a target="_blank" title="Download new line form">
                      <i class="fa fa-download"></i> {{ 'productSummary.downloadProductSpecifications' | cxTranslate }}</a
                      >
                    </p>
                  </div>
                  <div>
                    @for (document of product?.documents; track document; let index = $index) {
                      <p>
                        @if (document.documentDataType !== 'BIM_OBJECT') {
                          <a
                            class="tab-content__download-link"
                            (click)="activeLink = index; onDocumentClick(product, document)"
                            target="_blank"
                            title="{{ document.description }}"
                            >
                            <i
                              [ngClass]="spinner && activeLink === index ? 'fa-spinner fa-spin' : 'fa-download'"
                              class="fa"
                            ></i>
                            {{ document.description }}
                          </a>
                        }
                        @if (document.documentDataType === 'BIM_OBJECT') {
                          <a
                            class="tab-content__download-link"
                            href="{{ document.url }}"
                            target="_blank"
                            title="{{ document.description }}"
                            >
                            <i class="fa fa-download" aria-hidden="true"></i> {{ document.description }}
                          </a>
                        }
                      </p>
                    }
                  </div>
                }
              </div>
            </ng-template>
          </div>
        }
      }
    </div>
  }
  <div [style.display]="emptyProduct ? 'block' : 'none'">
    <app-error [errorMessage]="errorMessage"></app-error>
  </div>
